import { filter } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
//import { Options, QRCode } from 'ngx-qrcode-styling';
import { Storage } from '@ionic/storage';
import { CodebaseTranslateService } from '@app/services/codebase-translate.service';
import { MyroomComponent } from '@app/codebase/checkin/myroom/myroom.component';
import { GenericAlertComponent } from '../generic-alert/generic-alert.component';
import { UsersApiService } from '@app/core/users-api/users-api.service';
import { LoadingService } from '../services/loading.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss'],
})
export class QrCodeComponent implements OnInit {
  @Input() reservation: any;
  @Input() translates: any;
  title = 'app';
  elementType = 'object';
  public qrCodeValue: any = null;
  public changeValue : boolean = false;
  public config: any = null;
  // public config: Options = {
  //   width: 300,
  //   height: 300,
  //   data: null,
  //   // image: "assets/icons/logo-connect.png",
  //   margin: 5,
  //   rotate: 100,
  //   dotsOptions: {
  //     color: "#343536",
  //     // type: "rounded"
  //   },
  //   backgroundOptions: {
  //     color: "#ffffff",
  //   },
  //   imageOptions: {
  //     crossOrigin: "anonymous",
  //     margin: 5
  //   },
  //   cornersSquareOptions: {
  //     color: "#313131",
  //     // type: "extra-rounded"
  //   },
  //   cornersDotOptions: {
  //     color: "#313131",
  //     // type: "dot"

  //   }
  // };
  constructor(
    private router: Router,
    private storage: Storage,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private loading: LoadingService,
    public usersApi: UsersApiService,
    public translate: CodebaseTranslateService,
    private modalCtrlr: ModalController,) {
      if (!this.reservation) this.reservation = this.storage.get("reservationData"); }

  async ngOnInit() {
    if (!this.reservation) this.reservation = await this.storage.get("reservationData");
    this.qrCodeValue = {
      reservationId: this.reservation.reservationID,
      checkIn: this.reservation.startDate,
      checkOut: this.reservation.endDate,
      room: this.reservation.assigned && this.reservation.assigned.length ? this.reservation.assigned[0].roomName : 'unassigned'
    }
    console.log(this.qrCodeValue)
    this.config.data =  JSON.stringify(this.qrCodeValue)
    this.getData();
    // console.log(this.r)
  }

  async getData(){
    if (!environment.demoMode){
      await this.loading.presentLoading()
    }
    this.qrCodeValue = null;
    let rooms = null;
    if (this.reservation.assigned.find(item => item.Selected)){
      rooms = this.reservation.assigned.filter(item => item.Selected).map(item => item.roomName);
    }else{
      rooms = this.reservation.assigned.map(item => item.roomName);
    }
    this.qrCodeValue = {
      reservationId: this.reservation.reservationID,
      checkIn: this.reservation.startDate,
      checkOut: this.reservation.endDate,
      room: JSON.stringify(rooms)
    }
    console.log(this.qrCodeValue)
    // this.qrCode.addData(this.qrCodeValue)
    this.config.data = JSON.stringify(this.qrCodeValue)
    this.changeValue = false;
    await this.loading.dismiss()
  }

  async chooseRoom(idx){
    this.changeValue = true;
    this.reservation.assigned[idx].Selected = !this.reservation.assigned[idx].Selected;
    this.getData()
  }

  getSelected(){
    if (this.reservation.assigned.find(item => item.Selected)){
      return false;
    }else{
      return true;
    }
  }

  openRoomManager(){
    this.router.navigate(['/tabs/welcome-checkin/details-checkin'], {queryParams: {roomManager: true}});
    this.modalCtrlr.dismiss();
  }
  async ionViewDidEnter(){
    if (!this.reservation) this.reservation = await this.storage.get("reservationData");
    this.ngOnInit();
    console.log("ionViewDidEnter")
  }

  async onUserTap() {
    const test = await this.usersApi
      .isLoggedIn();

    console.log(test)
      // .then((loggedIn) => {
        if (test) {
          this.router.navigateByUrl(`/tabs/me`, {
            relativeTo: this.route,
          });
        } else {
          this.showLoginAlert();
        }
      // })
      // .catch((err) => {
      //   // error, not sure what to do here but let's show a login alert page
      //   this.showLoginAlert();
      // });
  }

  goBack(){
    this.modalCtrlr.dismiss();
  }

  async showLoginAlert() {
    // this.translateService.languageChange(this.homePage.languageSelected.val);
    const modal = await this.modalCtrlr.create({
      cssClass: "generic-alert-modal",
      component: GenericAlertComponent,
      componentProps: {
        title: this.translate.instant("MODAL_LOGIN.TITLE"),
        message: this.translate.instant("MODAL_LOGIN.SUBTITLE"),
        buttons: [
          {
            title: this.translate.instant("MODAL_LOGIN.BTN_LOGIN"),
            value: "login",
          },
          {
            title: this.translate.instant("MODAL_LOGIN.BTN_CANCEL"),
            value: "cancel",
          },
        ],
      },
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data && data.value === "login") {
      return this.navCtrl.navigateRoot(["/login"], {
        queryParams: { redirectUrl: this.router.url },
      });
    } else {
      return "";
    }
  }

  clickCheckOut(){
    this.modalCtrlr.dismiss();
    this.router.navigate(['/tabs/checkout']);

  }

  gotoHelp(){
    this.modalCtrlr.dismiss();
    this.router.navigate(['/tabs/help']);
  }

  async openRoomMap() {
    this.modalCtrlr.dismiss();
    this.router.navigate([`/tabs/myroom/${environment.demoMode ? '206' : this.reservation.assigned[0].roomName}`]);
  }

}
